export default {
  login: {
    succeed: "login_succeed",
    failed: "login_failed",
    usernameRequired: "username_required",
    passwordRequired: "password_required",
    systemFailed: "system_error"
  },
  loginSession: {
    succeed: "login_session_succeed",
    failed: "login_session__failed",
    ipRequired: "ip_required",
    systemFailed: "system_error"
  },
  logout: {
    succeed: "logout_succeed",
    failed: "logout_failed"
  },
  firstTime: {
    failed: "login_failed",
    newUsernameRequired: "new_username_required",
    newPasswordRequired: "new_password_required"
  },
  security: {
    failed: "security_failed",
    securityCodeRequired: "security_code_required"
  },
  addAccount: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed",
    loginIDRequired: "login_id_required",
    passwordRequired: "password_required"
  },
  editAccount: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed",
    profileIDRequired: "profile_id_required"
  },
  updatePassword: {
    succeed: "update_password_succeed",
    failed: "update_password_failed",
    passwordRequired: "password_required",
    newPasswordRequired: "new_password_required"
  },
  updateAuthority: {
    succeed: "update_authority_succeed",
    failed: "update_authority_failed"
  },
  subAccountBlock: {
    succeed: "block_sub_account_succeed",
    failed: "block_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  subAccountUnblock: {
    succeed: "unblock_sub_account_succeed",
    failed: "unblock_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  checkDirectDownline: {
    succeed: "check_downline_succeed",
    failed: "check_downline_failed",
    accountIDRequired: "account_id_required"
  },
  getOverviewSummary: {
    succeed: "get_overview_summary_succeed",
    failed: "get_overview_summary_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountWinlose: {
    succeed: "get_account_winlose_succeed",
    failed: "get_account_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountOutstanding: {
    succeed: "get_account_outstanding_succeed",
    failed: "get_account_outstanding_failed",
    accountIDRequired: "account_id_required"
  },
  getActiveAccount: {
    succeed: "get_active_account_succeed",
    failed: "get_active_account_failed",
    accountIDRequired: "account_id_required"
  },
  getTop10Account: {
    succeed: "get_top_10_account_succeed",
    failed: "get_top_10_account_failed",
    accountIDRequired: "account_id_required"
  },
  getPositionTaking: {
    succeed: "get_pt_succeed",
    failed: "get_pt_failed",
    accountIDRequired: "account_id_required"
  },
  getCommission: {
    succeed: "get_cm_succeed",
    failed: "get_cm_failed",
    accountIDRequired: "account_id_required"
  },
  getBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  getTournamentRefund: {
    succeed: "get_tournament_refund_succeed",
    failed: "get_tournament_refund_failed",
    accountIDRequired: "account_id_required"
  },
  getSchedule: {
    succeed: "get_schedule_succeed",
    failed: "get_schedule_failed",
    accountIDRequired: "account_id_required"
  },
  getCreditUsedSummary: {
    succeed: "get_credit_used_summary_succeed",
    failed: "get_credit_used_summary_failed",
    accountIDRequired: "account_id_required"
  },
  getWallet: {
    succeed: "get_wallet_succeed",
    failed: "get_wallet_failed",
    accountIDRequired: "account_id_required",
    accountTypeRequired: "account_type_required"
  },
  getPlatform: {
    succeed: "get_platform_succeed",
    failed: "get_platform_failed",
    accountIDRequired: "account_id_required"
  },
  getCreditUsedDownline: {
    succeed: "get_credit_used_downline_succeed",
    failed: "get_credit_used_downline_failed",
    accountIDRequired: "account_id_required"
  },
  updateAccountDetails: {
    succeed: "update_account_details_succeed",
    failed: "update_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountDetails: {
    succeed: "get_account_details_succeed",
    failed: "get_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountList: {
    succeed: "get_account_list_succeed",
    failed: "get_account_list_failed",
    accountIDRequired: "account_id_required"
  },
  getMemberList: {
    succeed: "get_member_list_succeed",
    failed: "get_member_list_failed",
    accountIDRequired: "account_id_required"
  },
  getMemberListAlert: {
    succeed: "get_member_list_succeed",
    failed: "get_member_list_failed",
    accountIDRequired: "account_id_required"
  },
  updateStatus: {
    succeed: "update_status_succeed",
    failed: "update_status_failed",
    accountIDRequired: "account_id_required",
    platformCodeRequired: "platform_code_required",
    platformNameRequired: "platform_name_required",
    statusRequired: "status_required"
  },
  resetWin: {
    succeed: "reset_accumulate_win_succeed",
    failed: "reset_accumulate_win_failed",
    accountIDRequired: "account_id_required"
  },
  unblockProfile: {
    succeed: "unblock_profile_succeed",
    failed: "unblock_profile_failed",
    profileIDRequired: "profile_id_required"
  },
  resetPassword: {
    succeed: "reset_password_succeed",
    failed: "reset_password_failed",
    accountIDRequired: "account_id_required",
    newPasswordRequired: "new_password_required"
  },
  updateCommissionSB: {
    succeed: "update_commission_sb_succeed",
    failed: "update_commission_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionMMO: {
    succeed: "update_commission_mmo_succeed",
    failed: "update_commission_mmo_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionSL: {
    succeed: "update_commission_sl_succeed",
    failed: "update_commission_sl_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLC: {
    succeed: "update_commission_lc_succeed",
    failed: "update_commission_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLO: {
    succeed: "update_commission_lo_succeed",
    failed: "update_commission_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionKN: {
    succeed: "update_commission_kn_succeed",
    failed: "update_commission_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionCF: {
    succeed: "update_commission_cf_succeed",
    failed: "update_commission_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionLT: {
    succeed: "update_commission_lt_succeed",
    failed: "update_commission_lt_failed",
    accountIDRequired: "account_id_required"
  },
  updateCommissionTN: {
    succeed: "update_commission_tn_succeed",
    failed: "update_commission_tn_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitSB: {
    succeed: "update_bet_limit_sb_succeed",
    failed: "update_bet_limit_sb_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLC: {
    succeed: "update_bet_limit_lc_succeed",
    failed: "update_bet_limit_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLO: {
    succeed: "update_bet_limit_lo_succeed",
    failed: "update_bet_limit_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitKN: {
    succeed: "update_bet_limit_kn_succeed",
    failed: "update_bet_limit_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitCF: {
    succeed: "update_bet_limit_cf_succeed",
    failed: "update_bet_limit_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updateBetLimitLT: {
    succeed: "update_bet_limit_lt_succeed",
    failed: "update_bet_limit_lt_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingSB1: {
    succeed: "update_position_taking_sb1_succeed",
    failed: "update_position_taking_sb1_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingSB2: {
    succeed: "update_position_taking_sb2_succeed",
    failed: "update_position_taking_sb2_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingMMO: {
    succeed: "update_position_taking_mmo_succeed",
    failed: "update_position_taking_mmo_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingSL: {
    succeed: "update_position_taking_sl_succeed",
    failed: "update_position_taking_sl_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLC: {
    succeed: "update_position_taking_lc_succeed",
    failed: "update_position_taking_lc_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLO: {
    succeed: "update_position_taking_lo_succeed",
    failed: "update_position_taking_lo_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingKN: {
    succeed: "update_position_taking_kn_succeed",
    failed: "update_position_taking_kn_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingCF: {
    succeed: "update_position_taking_cf_succeed",
    failed: "update_position_taking_cf_failed",
    accountIDRequired: "account_id_required"
  },
  updatePositionTakingLT: {
    succeed: "update_position_taking_lt_succeed",
    failed: "update_position_taking_lt_failed",
    accountIDRequired: "account_id_required"
  },
  getForecastLookup: {
    succeed: "get_forecast_lookup_succeed",
    failed: "get_forecast_lookup_failed",
    accountIDRequired: "account_id_required",
    betTypeRequired: "bet_type_required"
  },
  getForecastList: {
    succeed: "get_forecast_list_succeed",
    failed: "get_forecast_list_failed",
    accountIDRequired: "account_id_required",
    matchIDRequired: "match_id_required",
    subMatchIDRequired: "submatch_id_required",
    betTypeRequired: "bet_type_required"
  },
  getSettlementList: {
    succeed: "get_settlement_list_succeed",
    failed: "get_settlement_list_failed",
    accountIDRequired: "account_id_required"
  },
  settlement: {
    succeed: "settlement_succeed",
    failed: "settlement_failed",
    accountIDRequired: "account_id_required",
    settleAmountRequired: "settle_amount_required"
  },
  getTournamentJackpot: {
    succeed: "get_tournament_jackpot_succeed",
    failed: "get_tournament_jackpot_failed",
    accountIDRequired: "account_id_required"
  },
  getSettlementHistory: {
    succeed: "get_settlement_history_succeed",
    failed: "get_settlement_history_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyStatement: {
    succeed: "get_daily_statement_succeed",
    failed: "get_daily_statement_failed",
    accountIDRequired: "account_id_required"
  },
  getDailySettlement: {
    succeed: "get_daily_settlement_succeed",
    failed: "get_daily_settlement_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyWinlose: {
    succeed: "get_daily_winlose_succeed",
    failed: "get_daily_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getPlatformWinlose: {
    succeed: "get_platform_winlose_succeed",
    failed: "get_platform_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getSportTypeWinlose: {
    succeed: "get_sport_type_winlose_succeed",
    failed: "get_sport_type_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getLeagueWinlose: {
    succeed: "get_league_winlose_succeed",
    failed: "get_league_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required"
  },
  getMatchWinlose: {
    succeed: "get_match_winlose_succeed",
    failed: "get_match_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required"
  },
  getMatchMemberWinlose: {
    succeed: "get_match_member_winlose_succeed",
    failed: "get_match_member_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required",
    sportTypeRequired: "sport_type_required",
    leagueIDRequired: "league_id_required",
    matchIDRequired: "match_id_required"
  },
  getSystemParlay: {
    succeed: "get_system_parlay_succeed",
    failed: "get_system_parlay_failed",
    accountIDRequired: "account_id_required"
  },
  getLog: {
    urlRequired: "url_required",
    targetIDRequired: "target_id_required"
  },
  getMemberLog: {
    succeed: "get_member_log_succeed",
    failed: "get_member_log_failed",
    accountIDRequired: "account_id_required"
  },
  getBetlist: {
    succeed: "get_betlist_succeed",
    failed: "get_betlist_failed",
    accountIDRequired: "account_id_required",
    betTypeRequired: "bet_type_required",
    searchIDRequired: "search_id_required",
    matchIDRequired: "match_id_required",
    isLiveRequired: "is_live_required",
    homeRunningScoreRequired: "home_running_score_required",
    awayRunningScoreRequired: "away_running_score_required"
  },
  getGameResult: {
    succeed: "get_game_result_succeed",
    failed: "get_game_result_failed",
    accountIDRequired: "account_id_required",
    memberIDRequired: "member_id_required"
  },
  getPendingMatches: {
    succeed: "get_pending_matches_succeed",
    failed: "get_pending_matches_failed",
    accountIDRequired: "account_id_required"
  },
  getParlayDetail: {
    succeed: "get_parlay_detail_succeed",
    failed: "get_parlay_detail_failed",
    betIDRequired: "bet_id_required"
  },
  getEsportsDetailCombo: {
    succeed: "get_esports2_detail_combo_succeed",
    failed: "get_esports2_detail_combo__failed",
    betIDRequired: "bet_id_required"
  },
  getGameTypeLookup: {
    succeed: "get_game_lookup_succeed",
    failed: "get_game_lookup_failed"
  },
  getLeagueLookup: {
    succeed: "get_league_lookup_succeed",
    failed: "get_league_lookup_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required"
  },
  getMatchResult: {
    succeed: "get_match_result_succeed",
    failed: "get_match_result_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required",
    leagueIDRequired: "league_id_required"
  },
  checkDownline: {
    succeed: "check_downline_succeed",
    failed: "check_downline_failed",
    accountIDRequired: "account_id_required"
  },
  request: {
    succeed: "request_succeed",
    failed: "request_failed",
    processing: "request_processing"
  },
  session: {
    invalidToken: "invalid_token",
    expired: "session_expired",
    invalidSession: "invalid_session"
  },
  message: {
    succeed: "getMessageSucceed",
    failed: "getMessageFailed",
    startDateRequired: "startDateRequired",
    endDateRequired: "endDateRequired",
    anTypeRequired: "anTypeRequired"
  }
};
